import { Form, Input, Switch } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import MUploadImage from "../../../../component/UploadImage";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { fileService } from "../../shared/service/file.service";
import { Customer, CustomerUI } from "../entity/customer.model";
import { customerService } from "../service/customer.service";

function EditCustomer() {
  const { dispatch } = useContext(SpinContext);
  let { customerId } = useParams();
  let navigate = useNavigate();
  const [customer, setCustomer] = useState<CustomerUI>();

  useEffect(() => {
    dispatch({ type: spinActions.BLOCK });
    if (customerId) {
      customerService
        .getCustomer(customerId)
        .then((_customer: Customer) => {
          dispatch({ type: spinActions.UNBLOCK });

          helper.getImage(_customer.logo).then((file) => {
            setCustomer({
              ..._customer,
              image: file,
            });
          });
        })
        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    }

    return () => {
      setCustomer(undefined);
    };
  }, [customerId]);

  const onFinish = async (values: CustomerUI) => {
    if (customer) {
      let fileResponse;

      try {
        fileResponse = await fileService.uploadFile(values.image);
        customer.logo = fileResponse.fileName;
        customer.isSpecial = values.isSpecial;
      } catch (e) {
        return;
      }

      try {
        await customerService.editCustomer(customer);
        dialog.success("Харилцагч амжилттай шинэчлэгдлээ.");
        navigate("/customers");
      } catch (e) {
        return;
      }
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Харилцагчид", customer?.name ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">Харилцагчийн мэдээлэл</h5>
          </div>
          <div className="card-body">
            {customer && (
              <fieldset disabled={!helper.hasRoles(["customer-full"])}>
                <Form initialValues={customer} onFinish={onFinish}>
                  <div className="form-group">
                    <label>
                      Лого<span className="text-danger">*</span>
                    </label>

                    <Form.Item
                      name="image"
                      rules={[
                        {
                          required: true,
                          message: "Харилцагч байгууллагын логог оруулна уу.",
                        },
                      ]}
                    >
                      <MUploadImage
                        disabled={!helper.hasRoles(["customer-full"])}
                      />
                    </Form.Item>
                  </div>

                  <div className="form-group">
                    <label>Код</label>
                    <Form.Item name="uuid">
                      <Input readOnly={true} className="form-control" />
                    </Form.Item>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Ерөнхий нэр</label>
                        <Form.Item name="commonName">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Байгууллагын ажлын нэр</label>
                        <Form.Item name="name">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Байгууллагын регистер</label>
                        <Form.Item name="registryNumber">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>what3words</label>
                        <span className="text-danger">*</span>
                        <Form.Item name="what3words">
                          <Input className="form-control" readOnly={true} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Байгууллагын өргөрөг</label>
                        <Form.Item name="latitude">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Байгууллагын уртраг</label>
                        <Form.Item name="longitude">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Байгууллагын код</label>
                        <Form.Item name="companyCode">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Толгой байгууллагын регистер</label>
                        <Form.Item name="headCompanyRegister">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Толгой байгууллагын нэр</label>
                        <Form.Item name="headCompanyName">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Онцлох харилцагч эсэх</label>
                        <Form.Item name="isSpecial" valuePropName="checked">
                          <Switch />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <Authorization roles={["customer-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCustomer;
